import React, { useState, useContext } from "react";
import { DropdownItem, DropdownMenu, DropdownToggle, Dropdown, Modal, ModalHeader, ModalBody, Row } from "reactstrap";
import Avatar from "../common/Avatar";
import APITextingContext from "../../context/Context";
import { Button, Col, FormGroup, ModalFooter } from "react-bootstrap";
import axios from "axios";
import apiURL from "../../services/apiURL";
import authenticationService from "../../services/authenticationService";
const API_URL = apiURL("authentication");
const ProfileDropdown = () => {
  const { loginUserDetails,isDark } = useContext(APITextingContext);

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [openAPIAccessModal, setOpenAPIAccessModal] = useState(false);
  const toggle = () => setDropdownOpen((prevState) => !prevState);
  const [isDisable, setIsDisable] = useState(false)
  // i have used this to make sure user is redirected to login once logout api is called
  
  return (
    <>
      <Dropdown nav inNavbar isOpen={dropdownOpen} toggle={toggle}>
        <DropdownToggle nav className="mt-1 pr-0">
          <Avatar name={loginUserDetails.dev_name} />
        </DropdownToggle>
        <DropdownMenu right className="dropdown-menu-card">
          <div className={`rounded-soft py-1 ${isDark ? "dark-logout" : "bg-white"}`}>
            <DropdownItem
              // tag={Link}
              // to={`${process.env.PUBLIC_URL}/authentication/login`}
              onClick={() => {
                setOpenAPIAccessModal(true);
                setIsDisable(false)
              }
              }
            >
              Logout
            </DropdownItem>
          </div>
        </DropdownMenu>
      </Dropdown>
      <Modal
        isOpen={openAPIAccessModal}
        toggle={() => {
          setOpenAPIAccessModal(false);
        }}
        onClosed={() => {
          setOpenAPIAccessModal(false);
        }}
        size="md"
        scrollable={true}
        centered

      >
        <ModalHeader
          toggle={() => {
            setOpenAPIAccessModal(!openAPIAccessModal);
          }}
        >
          Log Out
        </ModalHeader>
        <ModalBody className="">
          <h5>
            Are you sure you want to logout ?
          </h5>
        </ModalBody>
        <ModalFooter>

          <FormGroup>
            <Col className="d-flex justify-content-end ">
              <Button
                className="mr-2"
                type="submit"
                variant="primary"
                size="sm"
                disabled={isDisable}
                onClick={() => {
                  authenticationService.logout();
                }
                }>
                Yes
              </Button>
              <Button
                variant="danger"
                size="sm"
                onClick={(e) => {
                  setOpenAPIAccessModal(false);
                }}
              >
                No
              </Button>
            </Col>
          </FormGroup>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default ProfileDropdown;
